import React from "react";
import "./Environmental.css";

const Environmental = () => {
  return (
    <div>
      <h1>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Harum, est?
      </h1>
    </div>
  );
};

export default Environmental;
